import React, { useState, useEffect } from 'react';
import { useSprings, animated } from '@react-spring/web';
import './LoadingDots.css';

const LoadingDots = () => {
  const config = { duration: 400 };
  const [index, setIndex] = useState(0);

  // Create the springs for 10 dots
  const springs = useSprings(6, [0, 1, 2, 3, 4, 5].map(i => ({
    transform: index === i ? 'scale(1.5)' : 'scale(0.5)',
    config,
  })));

  // Change the index to cycle through the dots
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % 6); // Now 10 dots
    }, 400); // Change every 400ms
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-container">
      {springs.map((spring, i) => (
        <animated.div key={i} style={spring} className="dot" />
      ))}
    </div>
  );
};

export default LoadingDots;
